import Qs from "qs";
import { faBinoculars } from "@fortawesome/pro-solid-svg-icons";
import { FunctionComponent, memo } from "react";
import { Link } from "react-router-dom";
import Page from "constants/page";
import { IProps } from "./explore-link.types";
import { EllipsisMenuItem } from "@edgetier/client-components";
import "./explore-link.scss";

/**
 * Link to the explore page with parameters pre-populated.
 * @param props.parameters Parameters to be added to the URL on the explore screen.
 * @param props.onClick    A function that will run after the link button is clicked.
 * @returns                Link button to the explore screen.
 */
const ExploreLink: FunctionComponent<IProps> = ({ parameters = {}, onClick }) => (
    <Link
        to={{
            pathname: Page.Explore,
            search: Qs.stringify(parameters, { addQueryPrefix: true, arrayFormat: "repeat", skipNulls: true }),
        }}
    >
        <EllipsisMenuItem onClick={onClick} icon={faBinoculars}>
            Explore
        </EllipsisMenuItem>
    </Link>
);

export default memo(ExploreLink);
